import _ from 'lodash'
import ChartDataTable from './chart-data-table'


/**
 * Shows or hides a chart data table and returns a handle to the backbone view if
 * it is rendered or null if it should be removed
 *
 * @param {Object} container the container to append the table to
 * @param {ChartDesigner} model the chart designer model to use for rendering
 */
function renderDataTable(container, model) {
	let chartTable = model.get('chartTable')
	let isShowingDataTable = !_.isNil(chartTable) && chartTable === true
	if (!isShowingDataTable || model.hasError()) return null

	const dataTable = new ChartDataTable({
		model: model,
		showData: true,
		showSeriesColor: true,
		showSeriesLabel: true
	})
	container.append(dataTable.el)

	dataTable.render()
	return dataTable
}

export default renderDataTable
renderDataTable.__filename__ = 'charts/render-chart-data-table.js'
